/**
 * returns system date with time set to 0
 * @returns {Date}
 */
export default () => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return today
}
